import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterService } from '../../master.service';

@Component({
  selector: 'app-billing-milestone-dialog',
  templateUrl: './billing-milestone-dialog.component.html',
  styleUrls: ['./billing-milestone-dialog.component.scss']
})

export class BillingMilestoneDialogComponent implements OnInit {
  public form: UntypedFormGroup;
  woTypeList: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<BillingMilestoneDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: UntypedFormBuilder,
    private masterService: MasterService
  ) {
    this.form = this.fb.group({
      billingMilestoneKey: [null],
      woTypeKey: [null, Validators.required],
      milestoneDescription: [null, Validators.required],
      status: ['ACTIVE']
    });
  }

  ngOnInit(): void {
    this.masterService.getAllActiveWoTypes().subscribe(res => this.woTypeList = res);
    if (this.data) this.form.patchValue(this.data);
  }

  close(): void { this.dialogRef.close(); }
}